import React, { useEffect, useState } from "react";
import styled from "styled-components";
import PartnerStateBar from "./../../../components/DeliveryDrivers/PartnerStateBar";
import PartnersList from "./../../../components/DeliveryDrivers/PartnersList";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as DeliveryDriversActions from "./../../../store/actions/DeliveryDrivers";

const statesToReset = [
  "driverListFilters",
  "driversList",
  "driversCount",
  "nextPage",
  "prevPage",
];

const DeliveryDrivers = ({
  getDriversCount,
  getDriversList,
  driversCount,
  driversList,
  driverListFilters,
  resetState,
}) => {
  const [activeDriverState, setActiveDriverState] = useState("");
  const [showShimmer, setShowShimmer] = useState(false);
  const defaultState = "LOGIN";

  const handleDriverStateClick = (state) => {
    setActiveDriverState(state);
    applyFilters(driverListFilters, state);
  };

  const applyFilters = (filters, driverState, noActiveFilters) => {
    if (!driverState) {
      setShowShimmer(true);
    }
    let newFilters = { ...filters };
    if (driverState || activeDriverState) {
      newFilters["login_status"] = driverState || activeDriverState;
    } else {
      newFilters["login_status"] = defaultState;
      setActiveDriverState(defaultState);
    }
    newFilters["page"] = 1;
    delete filters.page;
    getDriversList(newFilters);
    if (!driverState) {
      getDriversCount(filters).then((res) => {
        setShowShimmer(false);
      });
    }
  };

  const clearFilters = () => {
    statesToReset.forEach((state) => resetState(state));
  };

  const getFilters = () => {
    const updatedObj = { ...driverListFilters };
    delete updatedObj.page;
    return updatedObj;
  };

  return (
    <DeliveryDriverView>
      <PartnerStateBar
        count={driversCount}
        activeDriverState={activeDriverState}
        activeFilters={driverListFilters}
        handleClick={handleDriverStateClick}
        showShimmer={showShimmer}
      />
      <PartnersList
        clearFilters={clearFilters}
        list={driversList}
        applyFilters={applyFilters}
        allFilters={getFilters()}
      />
    </DeliveryDriverView>
  );
};

const DeliveryDriverView = styled.section`
  height: unset;
`;

function mapStateToProps(state) {
  const { DeliveryDrivers } = state;
  return {
    driversCount: DeliveryDrivers.driversCount,
    driversList: DeliveryDrivers.driversList,
    driverListFilters: DeliveryDrivers.driverListFilters,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getDriversCount: bindActionCreators(
      DeliveryDriversActions.getDriversCount,
      dispatch
    ),
    getDriversList: bindActionCreators(
      DeliveryDriversActions.getDriversList,
      dispatch
    ),
    resetState: bindActionCreators(DeliveryDriversActions.resetState, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DeliveryDrivers);
